// The API blanks every rich-text address that does not start with one of these schemes when it
// stores an event description or an announcement (sportya-api common/richText, ADR 0013). The
// editor refuses the same addresses and the announcement list blanks them in older records.
const SAFE_ADDRESS = /^(https?:\/\/|mailto:|tel:)/i

export const isSafeAddress = value => typeof value === "string" && SAFE_ADDRESS.test(value)
